import Event from './Event';
import Notification from './Notification';
import NotificationProduced from './events/NotificationProduced';
import NotificationConsumed from './events/NotificationConsumed';

export default (state: Notification[] = [], anyEvent: Event): Notification[] => {
    switch (anyEvent.type) {
        case NotificationProduced.type: {
            return [...state, (anyEvent as NotificationProduced).notification];
        }
        case NotificationConsumed.type: {
            return state.filter((notification: Notification) => notification.id !== (anyEvent as NotificationConsumed).id);
        }
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/core/notifications.ts